import React from "react";

import { CommonKeywordsSelect } from "./CommonKeywordsSelect";
import { CustomKeywordsSelect } from "./CustomKeywordsSelect";

import "./styles.scss";
interface IKeywordsSelectProps {
  keywords: { common: string[]; custom: string[] };
  setKeywords: (keywords: { common: string[]; custom: string[] }) => void;
}

export const KeywordsSelect = ({
  keywords,
  setKeywords,
}: IKeywordsSelectProps) => {
  const handleSelectCommonKeywords = (commonKeywords: string[]) => {
    setKeywords({
      ...keywords,
      common: commonKeywords,
    });
  };
  const handleSelectCustomKeywords = (customKeywords: string[]) => {
    setKeywords({
      ...keywords,
      custom: customKeywords,
    });
  };

  return (
    <div className="keywords-select">
      <CommonKeywordsSelect
        selectedKeywords={keywords.common}
        setSelectedKeywords={handleSelectCommonKeywords}
      />
      <CustomKeywordsSelect
        selectedKeywords={keywords.custom}
        setSelectedKeywords={handleSelectCustomKeywords}
      />
    </div>
  );
};
